import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { userApi } from '../userApi';
import type { DeleteUserRequest } from '../types';
import { MutationKey } from '@shared/config';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useDeleteUsers = (): UseMutationResult<
  {},
  AxiosError<TFormErrorResponse>,
  DeleteUserRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.DELETE_USERS],
    mutationFn: (data: DeleteUserRequest) => userApi.deleteUser(data),
  });
};
